import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { GetAllByUserPublic } from '../../../configurations/crud/opdCentersCrud';
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo';
import StatusContainer from '../../controls/StatusContainer';
import { EDoctorStatusBg, GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus';
import { Link, useParams } from 'react-router-dom';
import LoadingContainer from '../../controls/LoadingContainer';
import Empty from '../../controls/Empty';
import useGlobalLoader from '../../../configurations/useGlobalLoader';

export default function StartOPD() {
    const { start, end } = useGlobalLoader()
    const [opdCenters, setOpdCenter] = useState([]);
    const [loding, setLoding] = useState(false);
    const toast = useToast();
    const loginInfo = getLoginInfo()


    useEffect(() => {
        getAllOpdCenters()
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUserPublic({ DoctorId: loginInfo.doctorId })
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    setOpdCenter(mdata.data);
                } else {
                    setOpdCenter([]);
                    //toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setOpdCenter([]);
                //toast.open(errors, <MdErrorOutline />, "danger");
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    return (
        <Container>
            {
                !loding ?
                    opdCenters.length > 0 ?
                        <div className='h-full w-full flex flex-col items-center justify-center'>
                            <div class="h-full w-full lg:w-8/12 grid grid-rows md:grid-cols-2 gap-x-6">
                                {opdCenters.map(item =>
                                    <div class="w-full pb-6">
                                        <Card isBorder={true}>
                                            <div class="text-gray-900">
                                                <div class="justify-center flex flex-col items-center">
                                                    <div class="px-4 font-semibold text-xl">{item.centerName}</div>
                                                    <div class="text-sm">{item.address}</div>
                                                    <div class="px-4 py-2 font-semibold">Doctor's Status <StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} /></div>


                                                </div>
                                            </div>
                                            <div className='mt-2'>
                                                <ul class="text-md font-medium text-center text-white rounded-lg shadow flex">
                                                    <li class="w-full focus-within:z-10">
                                                        <Link to={"/doctor/" + item.id + "/center"} class="rounded-s-lg inline-block w-full p-4 bg-green-500 border-r border-gray-200  hover:bg-green-700 focus:outline-none">Doctor</Link>
                                                    </li>
                                                    <li class="w-full focus-within:z-10">
                                                        <Link to={"/display/" + item.id + "/center"} class="inline-block w-full p-4 bg-gray-400 border-r border-gray-200 hover:bg-gray-500 focus:outline-none">Display</Link>
                                                    </li>
                                                    <li class="w-full focus-within:z-10">
                                                        <Link to={"/reception/" + item.id + "/center"} class="rounded-e-lg inline-block w-full p-4 bg-blue-500 border-r border-gray-200  hover:bg-blue-700 focus:outline-none">Reception</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Card>

                                    </div>
                                )}

                            </div>
                        </div>
                        :
                        <Empty>
                            No OPD Centers Created.
                        </Empty>
                    :
                    <div className='w-full'>
                        <LoadingContainer text={"Getting centers to start OPD"} />
                    </div>
            }
        </Container>
    )
}
